import React from "react";

const NotFound = () => {
  return (
    <div>
      <h2>The Page is not found</h2>
      <h3>Http Error 404 Not Found</h3>
    </div>
  );
};

export default NotFound;
